import { BulletList as BuiltInBulletList, ListItem as BuiltInListItem, OrderedList as BuiltInOrderedList } from '@tiptap/extension-list'
import { NodeType } from '@tiptap/pm/model'
import { EditorState, Transaction } from '@tiptap/pm/state'
import { sharedAttrs } from '../shared/shared-attrs'

function swapListType(state: EditorState, dispatch: ((tr: Transaction) => void) | undefined, tr: Transaction, fromTypeName: string, toType: NodeType): boolean {
  const { $from } = state.selection

  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth)

    if (node.type.name === fromTypeName) {
      if (dispatch) {
        tr.setNodeMarkup($from.before(depth), toType, node.attrs)

        dispatch(tr)
      }
      return true
    }
  }

  return false
}

export const OrderedList = BuiltInOrderedList.extend({
  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  addCommands() {
    const parent = this.parent?.() ?? null

    if (parent === null) {
      return {}
    }

    return {
      ...parent,
      toggleOrderedList: () => (props) => {
        const { state, dispatch, tr } = props

        // Check if we're swapping list types and use our custom swap function to swap the list types so we preserve
        // our custom attribute data on the nodes.
        if (swapListType(state, dispatch, tr, 'bulletList', state.schema.nodes['orderedList'])) {
          return true
        }

        // Fallback to default behaviour we're not swapping lists.
        return parent.toggleOrderedList?.()(props)
      },
    }
  },
})

export const BulletList = BuiltInBulletList.extend({
  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  addCommands() {
    const parent = this.parent?.() ?? null

    if (parent === null) {
      return {}
    }

    return {
      ...parent,
      toggleBulletList: () => (props) => {
        const { state, dispatch, tr } = props

        // Check if we're swapping list types and use our custom swap function to swap the list types so we preserve
        // our custom attribute data on the nodes.
        if (swapListType(state, dispatch, tr, 'orderedList', state.schema.nodes['bulletList'])) {
          return true
        }

        // Fallback to default behaviour we're not swapping lists.
        return parent.toggleBulletList?.()(props)
      },
    }
  },
})

export const ListItem = BuiltInListItem.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      ...sharedAttrs,
      nodeId: {
        default: null,
        keepOnSplit: false,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-node-id'),
        renderHTML: (attrs: Record<string, any>) => (attrs['nodeId'] ? { 'data-node-id': attrs['nodeId'] } : {}),
      },
      templateItemId: {
        default: null,
        keepOnSplit: false,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-template-item-id'),
        renderHTML: (attrs: Record<string, any>) => (attrs['templateItemId'] ? { 'data-template-item-id': attrs['templateItemId'] } : {}),
      },
    }
  },
})

export const ListNodes = [OrderedList, BulletList, ListItem]
